define('evicommon/spf/model/sort',['require','exports','module','underscore','backbone'],function(require, exports, module){
  var _        = require('underscore');
  var Backbone = require('backbone');

  var SORT_FIELD = 'sort';
  var SORT_DIRECTION = 'sort.dir';
  var SORT_ASCENDING = 'ascending';
  var SORT_DESCENDING = 'descending';

  var SORT_DIRECTIONS = {};
  SORT_DIRECTIONS[SORT_ASCENDING] = 'asc';
  SORT_DIRECTIONS[SORT_DESCENDING] = 'desc';

  var Sort = Backbone.Model.extend({

    field: function() {
      if (arguments.length > 0) {
        this.set(SORT_FIELD, arguments[0]);
        return this;
      }
      return this.get(SORT_FIELD);
    },

    makeAscending: function() {
      this.set(SORT_DIRECTION, SORT_ASCENDING);
      return this;
    },

    makeDescending: function() {
      this.set(SORT_DIRECTION, SORT_DESCENDING);
      return this;
    },

    toQuery: function() {
      var args = [];

      if (this.has(SORT_FIELD)) {
        args.push(this.get(SORT_FIELD));
      }

      if (this.has(SORT_DIRECTION) && SORT_DIRECTIONS[this.get(SORT_DIRECTION)]) {
        args.push(SORT_DIRECTIONS[this.get(SORT_DIRECTION)].toUpperCase());
      }
      return _.map(args, encodeURIComponent).join(',');
    },

    toJSON: function() {
      var data = {};

      if (this.has(SORT_FIELD)) {
        data[SORT_FIELD] = this.get(SORT_FIELD);
      }

      if (this.has(SORT_DIRECTION) && SORT_DIRECTIONS[this.get(SORT_DIRECTION)]) {
        data[SORT_DIRECTION] = SORT_DIRECTIONS[this.get(SORT_DIRECTION)];
      }

      return data;
    }

  },
  {
    SORT_FIELD     : SORT_FIELD,
    SORT_DIRECTION : SORT_DIRECTION,
    ASCENDING      : SORT_ASCENDING,
    DESCENDING     : SORT_DESCENDING,

    createWithField: function(field, options) {
      var data = {};
      data[SORT_FIELD] = field;
      return new this(data, options);
    }

  });

  Sort.Collection = Backbone.Collection.extend({

    model: Sort,

    toQuery: function() {
      return this.invoke('toQuery').join(',');
    }

  });

  module.exports = Sort;
});
